import { isNotDefined } from './core.js';
import { isList, isObject } from './type.js';

/**
 * Pick only certain keys from an object
 * @param obj
 * @param keys
 */
const pick = (obj, keys) => keys.reduce((acc, key) => ({
  ...acc,
  [key]: obj[key]
}), {});

/**
 * Remove a certain key from an object
 * @param obj
 * @param key
 */
function removeKey(obj, key) {
  if (isNotDefined(obj) || !(key in obj)) {
    return obj;
  }
  const newObj = {
    ...obj
  };
  delete newObj[key];
  return newObj;
}

/**
 * Get key of the first element in an object
 * @param obj
 * @param value
 */
function getFirstKeyByValue(obj, value) {
  return Object.keys(obj).find(key => obj[key] === value);
}

/**
 * Identify if object has no data
 * @param obj
 * @param invalids list of values that aren't considered as data
 */
function doesObjectHaveNoData(obj) {
  let invalids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // NOTE: null and NaN are truthy values here
  if (obj === undefined) {
    return true;
  }
  if (isList(obj)) {
    if (obj.length <= 0) {
      return true;
    }
    return obj.every(e => doesObjectHaveNoData(e, invalids));
  }
  if (isObject(obj)) {
    if (Object.keys(obj).length <= 0) {
      return true;
    }
    return Object.keys(obj).every(key => doesObjectHaveNoData(obj[key], invalids));
  }
  return invalids.includes(obj);
}

export { doesObjectHaveNoData, getFirstKeyByValue, pick, removeKey };
//# sourceMappingURL=object.js.map
